import { useMemo } from "react";
import { useSelector } from "react-redux";
import { parseCancellationReasonsConfig } from "app/popleads/modules/extension/utils/constants";

// The company's `dealCancellationReasons` config, parsed once per value.
function useDealCancellationReasons() {
    const rawConfig = useSelector((state) => state.auth.user?.company?.companyConfig?.dealCancellationReasons);
    return useMemo(() => parseCancellationReasonsConfig(rawConfig), [rawConfig]);
}

export default useDealCancellationReasons;
